<template>
  <div>
    <div class="am-panel am-panel-default am-round am-margin-top" v-if="title">
      <div class="am-panel-bd am-text-center">
        {{title}}
      </div>
    </div>
    <article class="card" v-for="post in postList">
      <div class="card-title">
        <router-link :to="{path:`/post/${post.id}`}">{{post.title}}</router-link>
      </div>
      <div class="card-meta-top">
        <span class="card-meta-cate" v-if="post.typeList.length > 0">
          <i class="am-icon-bookmark"></i>
          <template v-for="type in post.typeList">
            <router-link :to="{path:`/type/${type.slug}`}">{{type.title}}</router-link> •
          </template>
        </span>
        <span class="card-meta-date">
          <i class="am-icon-clock-o"></i>
          {{post.createTime | dateFmt('YYYY-MM-DD')}}
        </span>
      </div>
      <router-link :to="{path:`/post/${post.id}`}">
        <div class="card-thumbnail" :style="{'background': `url(${post.banner}) center center no-repeat`, 'background-size': '100% auto'}"></div>
      </router-link>
      <div class="card-body">{{post.description}}</div>
      <div class="card-line"></div>
      <ul class="card-meta-bottom">
        <li class="card-meta-label"></li>
        <li class="card-meta-label am-fr"><i class="am-icon-comment-o"></i> {{post.commentCount}}</li>
        <li class="card-meta-label am-fr"><i class="am-icon-heart-o"></i> {{post.likeCount}}</li>
        <li class="card-meta-label am-fr"><i class="am-icon-eye"></i> {{post.viewCount}}</li>
      </ul>
    </article>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { apiTypeGet, apiTagGet, apiPostGetList } from '@/request'
export default {
  name: 'Index',
  data () {
    return {
      title: null,
      postList: []
    }
  },
  computed: {
    ...mapGetters([ 'option' ])
  },
  mounted () {
    this.resetData()
  },
  watch: {
    $route: {
      handler: 'resetData'
    },
    title () {
      this.seo()
    },
    option () {
      this.seo()
    }
  },
   methods: {
     resetData () {
       this.title = ''
       const { typeSlug, tagSlug } = this.$route.params
       if(typeSlug) {
         apiTypeGet({ slug: typeSlug }).then(res => {
           this.title = `分类 ${res.title} 下的文章`
         })
       }
       if(tagSlug) {
         apiTagGet({ slug: tagSlug }).then(res => {
           this.title = `标签 ${res.title} 下的文章`
         })
       }
       apiPostGetList({ typeSlug, tagSlug, typeData: true, description: true }).then(res => {
         this.postList = res
       })
     },
     seo () {
       if(this.title) {
         document.title = `${this.title}｜${this.option.title}`
         document.querySelector('meta[name="description"]').setAttribute('content', `${this.title}`)
         document.querySelector('meta[name="keywords"]').setAttribute('content', `${this.option.keywords},${this.title}`)
       } else {
         document.title = this.option.title
         document.querySelector('meta[name="description"]').setAttribute('content', this.option.description)
         document.querySelector('meta[name="keywords"]').setAttribute('content', this.option.keywords)
       }
     }
   }
}
</script>

<style scoped>
.card a {
  color: #333;
}
.card-title {
  font-size: 20px;
  line-height: 1.4;
}
.card-meta-top {
  margin: 10px 0;
}
.card-meta-top, .card-meta-top i {
  font-size: 13px;
}
.card-thumbnail {
  display: block;
  height: 320px;
  width: 100%;
  margin: 10px auto;
  box-sizing: border-box;
  overflow: hidden;
}
.card-body {
  overflow: hidden;
  margin-bottom: 10px;
  color: #555;
  font-size: 15px;
  line-height: 20px;
}
.card-line {
  width: 100%;
  height: 2px;
  margin: 10px 0;
  overflow: hidden;
  font-size: 0;
  border-bottom: 1px solid #e1e1e1;
}
.card-meta-bottom {
  padding: 0;
  margin: 0;
  list-style: none;
}
.card-meta-label {
  padding: 0;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  color: #8a8a8a;
  line-height: 1.3;
}
@media (max-width: 450px) {
  .card-thumbnail {
    height: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue